export default function displayAmount(amount, hasDecimal = false) {
  if (hasDecimal) {
    return amount.toLocaleString("en", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  return amount.toLocaleString();
}
